const wearingTypeEnum = {
  SPINE: 'spine',
  SHOULDER: 'shoulder',
  HEADSET: 'headset',
  HELMET: 'helmet',
};

export default wearingTypeEnum;
